<template>
  <absi-modal
    :no-close-backdrop="cookieCopy == null ? true : false"
    modal-name="consent-modal"
    :hide-header="true"
  >
    <template v-slot:activator>
      <the-consent-button @clickButton="openModal"></the-consent-button>
    </template>

    <template>
      <div class="consent-modal-wrapper">
        <close-modal-button
          @clickButton="closeModal"
          v-if="cookieCopy"
        ></close-modal-button>
        <b-row>
          <b-col>
            <b-row align-v="start" class="header-wrapper">
              <b-col>
                <img
                  class="modal-logo"
                  :src="require('@/assets/img/absi_logo.svg')"
                  alt=""
                />
              </b-col>
            </b-row>


            <b-row>
              <b-col>
                <h4 class="consent-modal-title">Husk – det er dit valg!</h4>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <p class="consent-text">
                  Vi benytter os af tredjepartstjenester for at indsamle
                  nødvendige oplysninger (browser information, ip, sporing
                  m.m.), som bruges til, at måle sidetrafik og lave analyser,
                  som i sidste ende er med til at gøre hjemmesiden mere brugbar
                  og give dig en bedre oplevelse. Derfor har vi brug for dit
                  samtykke til at fortsætte med at gøre hjemmesideoplevelsen
                  bedre.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h5 class="full-consent-title d-flex">
                  Acceptèr Alle
                  <b-badge v-if="cookieCopy === 'full_consent'">Valgt</b-badge>
                </h5>
                <p class="consent-text consent-text-1">
                  Ved at acceptere alle cookies accepterer du, at vi må indsamle
                  nødvendige data til at lave hjemmesideanalyse og benytte
                  tredjepartstjenester samt nødvendige funktionelle cookies.
                  <!-- <span class="full-consent-text consent-text-underlined"
                    >sacerdos flesh eater</span
                  > -->
                  <cookie-collapse
                    idName="full-consent"
                    :permission-details="fullConsent"
                  >
                    <template v-slot:activator>
                      <b-link
                        v-if="!toggleFull"
                        @click="toggleFull = !toggleFull"
                        class="button-collapse"
                        v-b-toggle.full-consent
                        >Se flere detaljer.</b-link
                      >
                      <b-link
                        v-if="toggleFull"
                        @click="toggleFull = !toggleFull"
                        class="button-collapse"
                        v-b-toggle.full-consent
                        >Se færre detaljer.</b-link
                      >
                    </template>
                  </cookie-collapse>
                </p>

                <h5 class="necessary-consent-title d-flex">
                  Nødvendige
                  <b-badge v-if="cookieCopy === 'necessary_consent'">
                    Valgt</b-badge
                  >
                </h5>
                <p class="consent-text consent-text-2">
                  Nødvendige funktionelle cookies hjælper med at optimere og
                  gøre hjemmesiden brugbar. Uden disse cookies vil hjemmesiden
                  ikke fungere optimalt.
                  <!-- <span class="necessary-consent-text consent-text-underlined"
                    >Sicut malus</span
                  > -->
                  <cookie-collapse
                    idName="necessary-consent"
                    :permission-details="necessaryConsent"
                  >
                    <template v-slot:activator>
                      <b-link
                        v-if="!toggleNecessary"
                        @click="toggleNecessary = !toggleNecessary"
                        class="button-collapse"
                        v-b-toggle.necessary-consent
                        >Se flere detaljer.</b-link
                      >
                      <b-link
                        v-if="toggleNecessary"
                        @click="toggleNecessary = !toggleNecessary"
                        class="button-collapse"
                        v-b-toggle.necessary-consent
                        >Se færre detaljer.</b-link
                      >
                    </template>
                  </cookie-collapse>
                </p>
              </b-col>
            </b-row>

            <b-row cols="12">
              <b-col>
                <div class="buttons-wrapper">
                  <b-button
                    @click="clickConsent('full')"
                    class="full-consent-button consent-modal-buttons"
                  >
                    <b-spinner
                      v-if="loading_full"
                      small
                      class="my-1 mr-1"
                      label="Loader"
                    ></b-spinner>
                    <span>Acceptér alle</span>
                  </b-button>
                  <b-button
                    @click="clickConsent('necessary')"
                    class="necessary-consent-button consent-modal-buttons"
                  >
                    <b-spinner
                      v-if="loading_necessary"
                      small
                      class="my-1 mr-1"
                      label="Loader"
                    ></b-spinner>
                    <span>Acceptér kun nødvendige</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </absi-modal>
</template>

<script>
import TheConsentButton from "./TheConsentButton";
import AbsiModal from "@/components/AbsiModal.vue";
import CookieCollapse from "./CookieCollapse";
import CloseModalButton from "@/components/CloseModalButton.vue";

export default {
  name: "TheConsentModal",
  components: {
    TheConsentButton,
    AbsiModal,
    CookieCollapse,
    CloseModalButton,
  },
  props: {
    cookie: {
      type: String,
      default: "necessary_consent",
    },
  },
  data() {
    return {
      toggleFull: false,
      toggleNecessary: false,
      fullConsent: [
        {
          type: "local storage",
          name: "wistia",
          service: "Wistia",
          purpose: "Indsamler oplysninger om brugen af videoafspiller",
          else: "Tredjepartstjeneste",
        },
      ],
      necessaryConsent: [
        {
          type: "cookies",
          name: "absi_consent",
          service: "absi ApS",
          expiration: "1 år",
          purpose: "Din samtykkeerklæring",
        },
      ],
      loading_full: false,
      loading_necessary: false,
      cookieCopy: this.cookie,
    };
  },
  mounted() {
    this.checkAndOpenCookie();
  },
  methods: {
    checkAndOpenCookie() {
      if (this.cookie) {
        this.closeModal();
      } else {
        this.openModal();
      }
    },
    openModal() {
      this.$root.$emit("bv::show::modal", "consent-modal", "#btnShow");
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "consent-modal", "#btnHide");
    },
    reloadWindow() {
      window.location.reload();
    },
    clickConsent(value) {
      if (this.cookie === `${value}_consent`) {
        this.closeModal();
      } else {
        this.$cookies.set(
          "absi_consent",
          `${value}_consent`,
          "1y",
          null,
          null,
          true,
          "Strict"
        );
        this.$emit("setCookie", `${value}_consent`);
        if (this.cookie || this.cookieCopy) {
          this[`loading_${value}`] = true;
          this.reloadWindow();
        } else {
          this.closeModal();
        }
        this.cookieCopy = `${value}_consent`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.consent-modal-wrapper {
  padding: 15px;

  .header-wrapper {
    margin-bottom: 36px;
    //
    .modal-logo {
      width: 115px;
      margin-top: 4px;
    }
  }

  .consent-modal-title {
    color: $primary;
    font-family: $medium;
    margin-top: 34px;
    font-size: $titles;
  }

  .full-consent-title,
  .necessary-consent-title {
    margin-top: 34px;
    font-size: $under-title;
    font-family: $medium;

    .badge {
      background-color: $primary;
      font-size: 64%;
      font-weight: 500;
      height: 16px;
      margin-left: 5px;
    }
  }
  .necessary-consent-title {
    margin-top: 54px;
  }

  .consent-text {
    font-size: $content;
  }

  .consent-text-underlined {
    color: $primary;
    text-decoration: underline;
  }

  .button-collapse {
    cursor: pointer;
    color: $primary;
  }

  .current-consent {
    font-family: $medium;
    color: $senary;
    border-bottom: 1px solid $senary;
    padding: 0 10px;
  }

  .buttons-wrapper {
    width: 100%;
    max-width: 300px;
    margin: auto;
    .consent-modal-buttons {
      width: 100%;
      margin-bottom: 24px;
      text-align: center;
      font-size: 20px;
      line-height: 20px;
      padding: 12px 0;
      border: 2px solid;
    }

    .full-consent-button {
      background-color: $primary;
      border-color: $primary;
      margin-top: 44px;

      &:hover,
      &:focus,
      &:active {
        background: $rgba-primary-1;
        border-color: $rgba-primary-1;
      }
    }

    .necessary-consent-button {
      background-color: transparent;
      color: $tertiary;
      border-color: $tertiary;
      margin-bottom: 54px;

      &:hover,
      &:focus,
      &:active {
        background-color: $tertiary;
        color: $secondary;
      }
    }
  }
}
</style>